/** Perbendaharaan kata prosedur KM my-act172.km-susun-atur 1.0.0 (Fasa 3 Perancangan, pelan P3-3b D-153). */
export default {
  stage: {
    osc_screening: 'Pra-semakan OSC',
    screening_returned: 'Dikembalikan semasa pra-semakan',
    awaiting_registration: 'Menunggu pendaftaran',
    cancelled: 'Dibatalkan',
    technical_review: 'Ulasan teknikal',
    written_direction: 'Arahan bertulis dikeluarkan (Borang A1)',
    rechecking: 'Menyemak semula pelan pindaan',
    neighbour_notice: 'Notis jiran dan bantahan',
    recommendation: 'Kertas perakuan',
    committee: 'Jawatankuasa OSC (JK OSC)',
    plan_amendment: 'Pindaan pelan (LDPP)',
    amendment_checking: 'Semakan pelan pindaan',
    mpfn_referral: 'Dirujuk kepada JPN dan MPFN',
    approved_pending_issue: 'Diluluskan, menunggu pengeluaran',
    final_plan_checking: 'Semakan pelan akhir',
    refusal_pending: 'Ditolak, menunggu surat penolakan',
    granted: 'Diberi kebenaran',
    extension_pending: 'Lanjutan dipohon',
    commenced: 'Kerja dimulakan',
    completed: 'Selesai',
    lapsed: 'Luput',
    refused: 'Ditolak (tempoh rayuan dibuka)',
    under_appeal: 'Dalam rayuan',
    refused_final: 'Ditolak (muktamad)',
    deemed_withdrawn: 'Disifatkan ditarik balik',
    escalated_to_state: 'Dirujuk kepada Pihak Berkuasa Negeri',
  },
  actions: {
    amend_check_errored: 'Semakan pelan pindaan tidak dapat dijalankan',
    amend_check_failed: 'Semakan pelan pindaan gagal',
    amend_check_passed: 'Semakan pelan pindaan lulus',
    amend_check_retry: 'Cuba semak pelan pindaan semula',
    amendment_lapsed: 'Rekod tempoh pindaan telah luput',
    amendment_submit: 'Hantar pelan pindaan',
    appeal_allowed: 'Rekod rayuan dibenarkan',
    appeal_dismissed: 'Rekod rayuan ditolak',
    appeal_grant_decided: 'Rekod keputusan rayuan terhadap kebenaran',
    appeal_grant_decided_commenced: 'Rekod keputusan rayuan terhadap kebenaran (kerja dimulakan)',
    appeal_grant_lodged: 'Rekod rayuan terhadap kebenaran',
    appeal_grant_lodged_commenced: 'Rekod rayuan terhadap kebenaran (kerja dimulakan)',
    appeal_grant_set_aside: 'Rekod kebenaran diketepikan atas rayuan',
    appeal_lodge: 'Rekod rayuan difailkan',
    appeal_window_closed: 'Tempoh rayuan tamat',
    approval_issue: 'Keluarkan kelulusan pelan bangunan',
    approval_void_with_parent: 'Batalkan bersama kebenaran merancang yang luput',
    bp_direction_deemed_withdrawn: 'Disifatkan ditarik balik: tempoh pindaan terlepas',
    bp_direction_extend: 'Lanjutkan tempoh pindaan',
    bp_direction_reinstate: 'Kembalikan kes pelan bangunan',
    c1_issue: 'Keluarkan Borang C1',
    c2_issue: 'Keluarkan Borang C2',
    charge_record: 'Rekod caj pemajuan',
    check_accept_exceptions: 'Terima semakan dengan pengecualian',
    circulate: 'Edarkan kepada agensi',
    committee_approve: 'Rekod kelulusan jawatankuasa',
    committee_approve_with_amendments: 'Rekod kelulusan dengan pindaan pelan (LDPP)',
    committee_cancel: 'Rekod pembatalan oleh jawatankuasa',
    committee_carry_over: 'Bawa ke mesyuarat seterusnya',
    committee_refuse: 'Rekod penolakan jawatankuasa',
    committee_table: 'Bentangkan dalam JK OSC',
    condition_complied: 'Rekod syarat yang dipatuhi',
    construction_complete: 'Rekod siap (CCC)',
    construction_start: 'Rekod permulaan kerja (Borang B)',
    decision_finalise: 'Penolakan menjadi muktamad',
    delegated_approve: 'Luluskan secara perwakilan kuasa',
    delegated_refuse: 'Tolak secara perwakilan kuasa',
    direction_comply: 'Rekod pematuhan arahan (Borang A2)',
    direction_deemed_withdrawn: 'Disifatkan ditarik balik: arahan tidak dipatuhi',
    direction_extend: 'Lanjutkan tempoh arahan',
    direction_issue: 'Keluarkan arahan bertulis (Borang A1)',
    direction_reinstate: 'Kembalikan kes',
    escalate_to_state: 'Rekod rujukan kepada Pihak Berkuasa Negeri',
    extension_circulate: 'Edarkan lanjutan kepada agensi',
    extension_recommend: 'Buat syor lanjutan',
    final_check_errored: 'Semakan pelan akhir tidak dapat dijalankan',
    final_check_failed: 'Semakan pelan akhir gagal',
    final_check_passed: 'Semakan pelan akhir lulus',
    final_check_retry: 'Cuba semak pelan akhir semula',
    final_plans_submit: 'Hantar pelan akhir',
    hearing_held: 'Rekod pendengaran bantahan',
    ldpp_letter_issued: 'Rekod surat pindaan dikeluarkan',
    mpfn_advised: 'Rekod nasihat MPFN',
    mpfn_refer: 'Rujuk kepada JPN dan MPFN',
    neighbours_notify: 'Beri notis kepada jiran',
    objection_record: 'Rekod bantahan',
    objections_closed: 'Tempoh bantahan tamat',
    paper_submit: 'Hantar kertas perakuan',
    paper_submit_after_notice: 'Hantar kertas perakuan selepas notis',
    parent_withdrawn: 'Tarik balik bersama kebenaran merancang yang ditarik balik',
    permit_apply_extension: 'Mohon lanjutan',
    permit_extend: 'Beri lanjutan',
    permit_lapse: 'Kebenaran luput',
    permit_refuse_extension: 'Tolak lanjutan',
    permit_renew: 'Rekod pembaharuan',
    prerequisite_record: 'Rekod item senarai semak',
    recheck_errored: 'Semakan semula tidak dapat dijalankan',
    recheck_failed: 'Semakan semula gagal',
    recheck_passed: 'Semakan semula lulus',
    recheck_retry: 'Cuba semakan semula sekali lagi',
    refusal_issue: 'Keluarkan surat penolakan',
    register: 'Daftar',
    register_building: 'Daftar pelan bangunan',
    screen_cancel: 'Batal: tempoh melengkapkan terlepas',
    screen_complete: 'Pra-semakan selesai',
    screen_expired: 'Tempoh melengkapkan tamat',
    screen_incomplete: 'Kembalikan kerana tidak lengkap',
    state_approved: 'Rekod kelulusan Pihak Berkuasa Negeri',
    state_refused: 'Rekod penolakan Pihak Berkuasa Negeri',
    withdrawal_close: 'Tutup penarikan balik',
  },
  inputs: {
    advice: 'Ringkasan nasihat',
    advisedOn: 'Tarikh nasihat',
    amendments: 'Pindaan yang diperlukan',
    appealRef: 'Rujukan rayuan',
    appealResult: 'Keputusan rayuan',
    appellant: 'Perayu',
    approvalNo: 'Nombor surat kelulusan',
    approvedOn: 'Tarikh kelulusan',
    boardOrderRef: 'Rujukan perintah Lembaga Rayuan',
    borangBStatus: 'Status Borang B kebenaran merancang',
    c1No: 'Nombor Borang C1',
    chargeAmount: 'Amaun caj (RM)',
    chargeReceipt: 'Nombor resit caj',
    chargeStatus: 'Caj pemajuan',
    commencedOn: 'Tarikh mula kerja (Borang B)',
    communicatedOn: 'Tarikh dimaklumkan kepada pemohon',
    completedOn: 'Tarikh siap (CCC)',
    conditionIds: 'Syarat yang dipatuhi',
    conditions: 'Syarat',
    decidedOn: 'Tarikh keputusan',
    delegated: 'Diputuskan secara perwakilan kuasa',
    directions: 'Arahan',
    evidence: 'Bukti',
    extendedOn: 'Tarikh lanjutan',
    extraDays: 'Hari tambahan',
    feeReceipt: 'Nombor resit fi',
    filing: 'Kaedah pemfailan',
    grounds: 'Alasan',
    hardcopyVerified: 'Salinan cetak disahkan',
    heldOn: 'Tarikh pendengaran',
    isf: 'Sumbangan infrastruktur (ISF) diselesaikan',
    issuedOn: 'Tarikh dikeluarkan',
    kmScale: 'Skala kebenaran merancang',
    kmValid: 'Kebenaran merancang sah',
    letterOn: 'Tarikh surat',
    lodgedOn: 'Tarikh difailkan',
    meetingNo: 'Nombor mesyuarat',
    meetingOn: 'Tarikh mesyuarat',
    noBuildingWorks: 'Tiada kerja bangunan',
    noLocalPlan: 'Tiada rancangan tempatan berkuat kuasa',
    note: 'Catatan',
    objectionReceivedOn: 'Tarikh bantahan diterima',
    objector: 'Pembantah',
    objectorNoticeOn: 'Tarikh notis kepada pembantah',
    orderOn: 'Tarikh perintah',
    period: 'Tempoh (hari)',
    pjp: 'PJP diselesaikan',
    pkt: 'PKT diselesaikan',
    praJkOn: 'Tarikh mesyuarat Pra-JK',
    proposedConditions: 'Syarat yang dicadangkan',
    receiptOn: 'Tarikh diterima',
    receivedOn: 'Tarikh diterima',
    refusalRef: 'Rujukan surat penolakan',
    refusedOn: 'Tarikh penolakan',
    registeredOn: 'Tarikh pendaftaran',
    renewalRef: 'Rujukan pembaharuan',
    renewedOn: 'Tarikh pembaharuan',
    s18Deposit: 'Deposit atau pengecualian seksyen 18',
    scale: 'Skala',
    scheduledOn: 'Tarikh mesyuarat dirancang',
    servedOn: 'Tarikh penyampaian',
    stampingPlans: 'Pelan untuk dicop diterima',
    stateDecidedOn: 'Tarikh keputusan Negeri',
    stateRef: 'Rujukan surat Negeri',
    stateRefusalRef: 'Rujukan surat penolakan Negeri',
    summary: 'Ringkasan',
    syor: 'Syor',
    window: 'Tempoh ulasan (hari)',
    worksNotStopped: 'Kerja tidak terhenti lebih daripada tiga bulan',
  },
  clocks: {
    osc_screening: 'Pra-semakan OSC',
    applicant_completion: 'Pelengkapan oleh pemohon',
    circulation: 'Edaran kepada agensi',
    technical_comment: 'Ulasan agensi',
    kpkt_first_hearing: 'Pendengaran pertama (KPKT)',
    kpkt_decision: 'Keputusan (KPKT)',
    paper_due: 'Kertas perakuan perlu disediakan',
    written_direction: 'Arahan bertulis (Borang A2)',
    neighbour_objection: 'Bantahan jiran',
    objection_hearing: 'Pendengaran bantahan',
    ldpp_amendment: 'Pindaan pelan (LDPP)',
    bp_direction: 'Pindaan pelan bangunan',
    bp_decision_window: 'Keputusan pelan bangunan (tiga bulan)',
    reinstate_window: 'Tempoh pengembalian',
    documentation: 'Dokumen selepas kelulusan',
    appeal_window: 'Tempoh rayuan',
    appeal_grace: 'Tempoh tangguh rayuan lewat',
    appeal_window_grant: 'Rayuan terhadap kebenaran',
    validity: 'Tempoh sah',
  },
  flags: {
    scale: 'Skala',
    noLocalPlan: 'Tiada rancangan tempatan berkuat kuasa',
    noticeRequired: 'Notis jiran diperlukan',
    delegated: 'Laluan perwakilan kuasa',
    noBuildingWorks: 'Tiada kerja bangunan',
    amendmentLapsed: 'Tempoh pindaan luput',
    filing: 'Kaedah pemfailan',
    objectionsClosed: 'Tempoh bantahan tamat',
    hearingSettled: 'Pendengaran selesai',
    committeeOutcome: 'Keputusan jawatankuasa',
    chargeStatus: 'Caj pemajuan',
    chargeSettled: 'Caj pemajuan diselesaikan',
    stampingPlans: 'Pelan untuk dicop diterima',
    isf: 'ISF diselesaikan',
    kmValid: 'Kebenaran merancang sah',
    pjp: 'PJP diselesaikan',
    pkt: 'PKT diselesaikan',
    s18Deposit: 'Deposit atau pengecualian seksyen 18',
    grantAppealOpen: 'Rayuan terhadap kebenaran terbuka',
    extensionRecommended: 'Lanjutan disyorkan',
    appealAllowed: 'Rayuan dibenarkan',
  },
  counters: {
    hearings: 'Pendengaran',
    objections: 'Bantahan',
    extensions: 'Lanjutan',
    ldppLetters: 'Surat pindaan',
    directionExtensions: 'Lanjutan arahan',
    bpDirectionExtensions: 'Lanjutan pindaan pelan bangunan',
    renewals: 'Pembaharuan',
  },
  /** Design Q26 (decided 2026-10-29): the form's notice beside `nama` and `pemaju`; awaits a native speaker's review. */
  form: {
    registerNotice: 'Nama pemaju dan nama pemajuan dilaporkan kepada PLANMalaysia dalam daftar guna tanah komited.',
  },
} as const
